<template>
  <div class="headertop" variant="warning">
    <b-container fluid class="bg-warning">
			<b-row >
				<b-col lg="5" md="5" sm="12">
          <b-link :href="$root.getDashboardLink()"><b-img src="../assets/logo.png" fluid alt="logo" class="logo"></b-img></b-link>
          
					Nagar Nigam Aligarh
				</b-col>
        <b-col lg="2" md="2" sm="12">
          <!-- <b-link :href="$root.getDashboardLink()"><b-img src="../assets/logo2.png" fluid alt="logo" class="logo2"></b-img></b-link> -->
        </b-col>
				<b-col lg="5" md="5" sm="12">
          <b-navbar class="m-0 p-0">
          <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item v-if="$root.chkperm('find_device','enabled')" >
              <div class="input-group  searchBox">
            <input type="text" class="form-control searchimei" v-model="imeino" placeholder="IMEI No. /FP No." aria-label="IMEI No. /FP No." aria-describedby="basic-addon2">
            <span class="input-group-text" @click="$root.search_sidebar = true"><b-img src="../assets/search-icon.svg"></b-img> </span>
          </div>
          </b-nav-item>
           
         
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <strong>Welcome,</strong> <em>{{$session.get('user_info').username}} <b-img src="../assets/user.svg" class="nav-profile"></b-img></em>
            </template>
            <b-dropdown-item href="#" v-b-modal="'password-modal'" v-if="$root.chkperm('change_password','enabled')">Change Password</b-dropdown-item>
            <b-dropdown-item href="/logout">Logout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
        </b-collapse>
      </b-navbar>
				</b-col>
				
			</b-row>
		</b-container>
      
    <search-sidebar :search="imeino"></search-sidebar>
  </div>
</template>

<script>
import Search from "@/components/Search.vue";
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:{
    "search-sidebar": Search,
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
      
      current_password: '', 
      new_password: '',
      passwordUrl: this.$session.get('apiurl')+'aligarhapi/change-password',
      imeino:''
    }
  },
  methods:{
    resetSelectedItem(){
      this.current_password = '';
      this.new_password = '';
    },
    modalSubmit(bvModalEvt){
      var self = this;
      //self.loading = true;
      bvModalEvt.preventDefault();
      var submitUrl = self.passwordUrl;

      var o = {'cp': this.current_password, 'np': this.new_password};

      self.axios.post(submitUrl, {
        accesskey: self.$session.get('access_key'),
        data: o
      })
      .then(function (response) {
        if(response.data.error == 0 || response.data.error == '0'){
          self.$bvModal.hide('my-modal');
          self.$bvToast.toast(response.data.message, {
            title: 'Status',
            toaster: 'b-toaster-bottom-right',
            autoHideDelay: 5000,
            variant: 'warning',
            solid: true,
            appendToast: true
          });
        }
        
      })
      .catch(function (error) {
        alert(error);
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.headertop{  
  top:0px;
  width: 100%;
  z-index: 10;
  .logo{
    margin: 6px;
    width: 41px;
  }
  .logo2{
    margin: 6px;
    height: 41px;
  }
  .searchBox{
     
     .searchimei{    
      border-right: 0px;
      height: 30px;
      width: 165px;
      font-size: 14px;
     }
     .input-group-text{
      background: #fff;
      border-left: 0px;
      margin-left: -2px;
        img{
        width: 14px;
      } 
     }
     
  }

  .nav-profile {
    width: 36px;
    height: 35px;
    border-radius: 100%;
    background: #fff;
    padding: 8px;
  }
  .bg-warning{
    background-color: #FF9F43 !important;
}
  
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}


</style>
